'use strict';

const { validateElement } = require('../../../vue-form/vue-input/libs/validator');

module.exports = (privacyDTO) => {
    return {
        namespaced: true,
        state: {
            ...privacyDTO,
        },
        getters: {
            isValid(state) {
                if (!state.show || !state.checkbox) {
                    return true;
                }
                return validateElement(state.checkbox).length === 0;
            }
        },
        actions: { },
        mutations: {
            updateCheckboxValue(state, value) {
                if (!state.show || !state.checkbox) {
                    return;
                }
                state.checkbox.state.value = value;
                state.checkbox.validationErrors = validateElement(state.checkbox);
            },
            validate(state) {
                if (!state.show || !state.checkbox) {
                    return;
                }
                state.checkbox.validationErrors = validateElement(state.checkbox);
            }
        }
    };
};
